import React from 'react'

import Page from '../../../components/pdf/Page'
import PdfHeader from './general/PdfHeader'
import RepliesSection from './replies/RepliesSection'

const PdfDocument = () => {
  return (
    <Page>
      <PdfHeader />
      <RepliesSection />
    </Page>
  )
}

export default PdfDocument
